export default __webpack_public_path__ + "static/media/wetu.fd9ac292.svg";